exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".plan-details-display{padding-top:8px;padding-right:8px;padding-bottom:8px;margin-bottom:25px;max-width:768px;border:1px solid #b8babd}.plan-details-display .plan-details{display:inline-block}.plan-details-display .sub-section-title{margin:0;padding-top:2px;padding-left:20px;font-size:24px;font-weight:500;line-height:34px;color:#444;display:inline-block}.plan-details-display .price-box{display:inline-block;font-weight:700;width:100%}.plan-details-display .price-box .previous-price{text-align:center;text-decoration:line-through;font-family:Gotham Rounded,Helvetica Neue,Arial,Sans-serif}.plan-details-display .price-box .price{text-align:center;font-size:36px;font-weight:700;line-height:36px}.plan-details-display .price-box .term-text{text-align:center}@media (min-width:992px){.plan-details-display .price-box{float:right;vertical-align:top;width:100px;margin:32px 16px}}.current-plan-details{width:100%;background:#f7f5f5;border-color:#e4e4e4;border-radius:5px;max-width:100%}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/Plans/PlanDetails/PlanDetails.scss
 ** module id = 1209
 ** module chunks = 0
 **/